import { useImageNotesDialogOpened } from './../listerUploadVehicle/v2';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

type ReviewVehicleState = {
  createBannerDialogOpened: boolean;
  imageNotesDialogOpenedId: string | null;
  enlargeDialogOpenedIndex: number | null;
  enlargeOnHover: boolean;
};

const initialState: ReviewVehicleState = {
  createBannerDialogOpened: false,
  imageNotesDialogOpenedId: null,
  enlargeDialogOpenedIndex: null,
  enlargeOnHover: false
};

const reviewVehicleSlice = createSlice({
  name: 'reviewVehicle',
  initialState,
  reducers: {
    openCreateBannerDialog: state => {
      state.createBannerDialogOpened = true;
    },
    closeCreateBannerDialog: state => {
      state.createBannerDialogOpened = false;
    },
    openImageNotesDialog: (state, action: PayloadAction<string>) => {
      state.imageNotesDialogOpenedId = action.payload;
    },
    closeImageNotesDialog: state => {
      state.imageNotesDialogOpenedId = null;
    },
    openEnlargeDialog: (state, action: PayloadAction<number>) => {
      state.enlargeDialogOpenedIndex = action.payload;
    },
    closeEnlargeDialog: state => {
      state.enlargeDialogOpenedIndex = null;
    },
    toggleEnlargeOnHover: state => {
      state.enlargeOnHover = !state.enlargeOnHover;
    }
  }
});

export const useCreateBannerDialogOpened = () => {
  const fullScreenImageModalOpen = useSelector<{ reviewVehicle: ReviewVehicleState }, boolean>(
    state => state.reviewVehicle.createBannerDialogOpened
  );
  return fullScreenImageModalOpen;
};

export const useImageNotesDialogId = () => {
  const fullScreenImageModalOpen = useSelector<{ reviewVehicle: ReviewVehicleState }, string | null>(
    state => state.reviewVehicle.imageNotesDialogOpenedId
  );
  return fullScreenImageModalOpen;
};

export const useEnlargeDialogId = () => {
  const fullScreenImageModalOpen = useSelector<{ reviewVehicle: ReviewVehicleState }, number | null>(
    state => state.reviewVehicle.enlargeDialogOpenedIndex
  );
  return fullScreenImageModalOpen;
};

export const useEnlargeOnHover = () => {
  const enlargeOnHover = useSelector<{ reviewVehicle: ReviewVehicleState }, boolean>(
    state => state.reviewVehicle.enlargeOnHover
  );
  return enlargeOnHover;
};


export const {
  openCreateBannerDialog,
  closeCreateBannerDialog,
  openImageNotesDialog,
  closeImageNotesDialog,
  openEnlargeDialog,
  closeEnlargeDialog,
  toggleEnlargeOnHover
} = reviewVehicleSlice.actions;
export default reviewVehicleSlice;
